<template>

  <head>

    <meta charset="utf-8" />
    <title>Desk Birdy | Business Permits</title>
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <meta content="Rental management system by Nouveta LTD" name="description" />
    <meta content="Kelvin Njuguna" name="author" />
    <!-- App favicon -->
    <link rel="shortcut icon" href="assets/images/favicon.svg">
    <!-- droping file -->
    <link href="assets/libs/dropzone/min/dropzone.min.css" rel="stylesheet" type="text/css" />

    <!-- DataTables -->
    <link href="assets/libs/datatables.net-bs4/css/dataTables.bootstrap4.min.css" rel="stylesheet" type="text/css" />
    <link href="assets/libs/datatables.net-buttons-bs4/css/buttons.bootstrap4.min.css" rel="stylesheet"
          type="text/css" />

    <!-- Bootstrap Css -->
    <link href="assets/css/bootstrap.min.css" id="bootstrap-style" rel="stylesheet" type="text/css" />
    <!-- Bootstrap select styling -->
    <link rel="stylesheet"
          href="https://cdn.jsdelivr.net/npm/bootstrap-select@1.13.14/dist/css/bootstrap-select.min.css">
    <!-- Icons Css -->
    <link href="assets/css/icons.min.css" rel="stylesheet" type="text/css" />
    <!-- App Css-->

    <!-- owl.carousel css -->
    <link rel="stylesheet" href="assets/libs/owl.carousel/assets/owl.carousel.min.css">

    <link rel="stylesheet" href="assets/libs/owl.carousel/assets/owl.theme.default.min.css">

    <link href="assets/css/app.min.css" id="app-style" rel="stylesheet" type="text/css" />
    <!-- custom Css-->
    <link href="assets/css/custom.css" id="app-style" rel="stylesheet" type="text/css" />

  </head>

  <body data-sidebar="dark">

  <!-- Begin page -->
  <div id="layout-wrapper">


    <!-- ========== Left Sidebar Start ========== -->
    <NavigationBar/>
    <!-- Left Sidebar End -->

    <!-- ============================================================== -->
    <!-- Start right Content here -->
    <!-- ============================================================== -->




    <div class="main-content">

      <div class="page-content">
        <div class="container-fluid">

          <!-- start page title -->
          <div class="row">
            <div class="col-12">
              <div class="page-title-box d-sm-flex align-items-center justify-content-between">
                <h4 class="mb-sm-0 font-size-18">Rejected Applications</h4>

                <div class="page-title-right">
                  <ol class="breadcrumb m-0">
                    <li class="breadcrumb-item"><a href="javascript: void(0);">Dashboard</a></li>
                    <li class="breadcrumb-item active">E Construction</li>
                    <li class="breadcrumb-item active">Rejected APplications</li>
                  </ol>
                </div>

              </div>
            </div>
          </div>
          <!-- end page title -->
          <div class="row">
            <div class="col-12">
              <div class="card">

                <div class="card-body">
                  <div class="table-responsive">
                    <table class="table align-middle table-striped table-nowrap table-hover contacts-table" id="datatable-buttons">
                      <thead class="table-dark">
                      <tr>
                        <th scope="col">#</th>
                        <th scope="col">Application Date</th>
                        <th scope="col">Application Number</th>
                        <th scope="col">Project Name</th>
                        <th scope="col">Development Type</th>
                        <th scope="col">Sub County</th>
                        <th scope="col">Ward</th>
                        <th scope="col">Plot Number</th>
                        <th scope="col">Rejection Date</th>
                        <th scope="col">Rejected By</th>
                        <th scope="col" class="text-right">Reason for Rejection</th>
                        <th scope="col">Notes</th>
                        <th></th>
                      </tr>
                      </thead>

                      <tbody>
                      <tr>
                        <td class="text-capitalize">1.</td>
                        <td class="text-capitalize">2023-05-18</td>
                        <td>BPA-2023-001</td>
                        <td>Proposed Residential House</td>
                        <td>New Buildings</td>
                        <td>Homa Bay Town</td>
                        <td>Arujo</td>
                        <td>LR 1234/567</td>
                        <td>2023-05-20</td>
                        <td>John Doe</td>
                        <td class="text-black text-uppercase text-right"><strong>Funding Verification Required</strong></td>
                        <td>Lack of clear financial sustainability plan</td>
                        <td>
                          <div class="btn-group">
                            <button class="btn btn-danger btn-sm" data-toggle="modal" data-target="#details-3">View Rejection Details</button>
                            <button class="btn btn-secondary btn-sm dropdown-toggle" type="button" data-bs-toggle="dropdown" aria-expanded="false"></button>
                            <ul class="dropdown-menu">
                              <li><a class="dropdown-item" href="#">Download Rejection Notice</a></li>
                            </ul>
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <td class="text-capitalize">2.</td>
                        <td class="text-capitalize">2023-05-22</td>
                        <td>BPA-2023-003</td>
                        <td>Proposed Warehouse</td>
                        <td>Structural Engineering Designs & Supervision</td>
                        <td>Oyugis</td>
                        <td>West Kasipul</td>
                        <td>LR 4567/890</td>
                        <td>2023-05-25</td>
                        <td>Jane Smith</td>
                        <td class="text-black text-uppercase text-right"><strong>Zoning Regulation Violation</strong></td>
                        <td>Location does not comply with zoning laws</td>
                        <td>
                          <div class="btn-group">
                            <button class="btn btn-danger btn-sm" data-toggle="modal" data-target="#details-3">View Rejection Details</button>
                            <button class="btn btn-secondary btn-sm dropdown-toggle" type="button" data-bs-toggle="dropdown" aria-expanded="false"></button>
                            <ul class="dropdown-menu">
                              <li><a class="dropdown-item" href="#">Download Rejection Notice</a></li>
                            </ul>
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <td class="text-capitalize">3.</td>
                        <td class="text-capitalize">2023-05-28</td>
                        <td>BPA-2023-005</td>
                        <td>Proposed Factory</td>
                        <td>Civil Engineering Designs, works & clearing</td>
                        <td>Rangwe</td>
                        <td>Kagan</td>
                        <td>LR 6789/012</td>
                        <td>2023-05-30</td>
                        <td>Mike Johnson</td>
                        <td class="text-black text-uppercase text-right"><strong>Insufficient Safety Documentation</strong></td>
                        <td>Safety plans do not meet building codes</td>
                        <td>
                          <div class="btn-group">
                            <button class="btn btn-danger btn-sm" data-toggle="modal" data-target="#details-3">View Rejection Details</button>
                            <button class="btn btn-secondary btn-sm dropdown-toggle" type="button" data-bs-toggle="dropdown" aria-expanded="false"></button>
                            <ul class="dropdown-menu">
                              <li><a class="dropdown-item" href="#">Download Rejection Notice</a></li>
                            </ul>
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <td class="text-capitalize">4.</td>
                        <td class="text-capitalize">2023-06-02</td>
                        <td>BPA-2023-007</td>
                        <td>Proposed Shopping Complex</td>
                        <td>Commercial Development</td>
                        <td>Rachuonyo South</td>
                        <td>Nyalenda</td>
                        <td>LR 9012/345</td>
                        <td>2023-06-05</td>
                        <td>Emily Brown</td>
                        <td class="text-black text-uppercase text-right"><strong>Parking Inadequacy</strong></td>
                        <td>Insufficient parking space for proposed development</td>
                        <td>
                          <div class="btn-group">
                            <button class="btn btn-danger btn-sm" data-toggle="modal" data-target="#details-3">View Rejection Details</button>
                            <button class="btn btn-secondary btn-sm dropdown-toggle" type="button" data-bs-toggle="dropdown" aria-expanded="false"></button>
                            <ul class="dropdown-menu">
                              <li><a class="dropdown-item" href="#">Download Rejection Notice</a></li>
                            </ul>
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <td class="text-capitalize">5.</td>
                        <td class="text-capitalize">2023-06-10</td>
                        <td>BPA-2023-009</td>
                        <td>Proposed Hospital Extension</td>
                        <td>Healthcare Facility Expansion</td>
                        <td>Rachuonyo South</td>
                        <td>Central</td>
                        <td>LR 3456/789</td>
                        <td>2023-06-15</td>
                        <td>David Wilson</td>
                        <td class="text-black text-uppercase text-right"><strong>Environmental Impact Concerns</strong></td>
                        <td>Potential ecological disruption in sensitive area</td>
                        <td>
                          <div class="btn-group">
                            <button class="btn btn-danger btn-sm" data-toggle="modal" data-target="#details-3">View Rejection Details</button>
                            <button class="btn btn-secondary btn-sm dropdown-toggle" type="button" data-bs-toggle="dropdown" aria-expanded="false"></button>
                            <ul class="dropdown-menu">
                              <li><a class="dropdown-item" href="#">Download Rejection Notice</a></li>
                            </ul>
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <td class="text-capitalize">6.</td>
                        <td class="text-capitalize">2023-06-18</td>
                        <td>BPA-2023-011</td>
                        <td>Proposed Resort</td>
                        <td>Tourism Infrastructure</td>
                        <td>Rachuonyo South</td>
                        <td>Kombe</td>
                        <td>LR 7890/123</td>
                        <td>2023-06-22</td>
                        <td>Sarah Green</td>
                        <td class="text-black text-uppercase text-right"><strong>Coastal Protection Violation</strong></td>
                        <td>Encroachment on protected coastal zone</td>
                        <td>
                          <div class="btn-group">
                            <button class="btn btn-danger btn-sm" data-toggle="modal" data-target="#details-3">View Rejection Details</button>
                            <button class="btn btn-secondary btn-sm dropdown-toggle" type="button" data-bs-toggle="dropdown" aria-expanded="false"></button>
                            <ul class="dropdown-menu">
                              <li><a class="dropdown-item" href="#">Download Rejection Notice</a></li>
                            </ul>
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <td class="text-capitalize">7.</td>
                        <td class="text-capitalize">2023-06-25</td>
                        <td>BPA-2023-013</td>
                        <td>Proposed School Building</td>
                        <td>Educational Infrastructure</td>
                        <td>Rachuonyo</td>
                        <td>Kamhacia</td>
                        <td>LR 2345/678</td>
                        <td>2023-06-30</td>
                        <td>Michael Lee</td>
                        <td class="text-black text-uppercase text-right"><strong>Land Use Restriction</strong></td>
                        <td>Proposed site not zoned for educational use</td>
                        <td>
                          <div class="btn-group">
                            <button class="btn btn-danger btn-sm" data-toggle="modal" data-target="#details-3">View Rejection Details</button>
                            <button class="btn btn-secondary btn-sm dropdown-toggle" type="button" data-bs-toggle="dropdown" aria-expanded="false"></button>
                            <ul class="dropdown-menu">
                              <li><a class="dropdown-item" href="#">Download Rejection Notice</a></li>
                            </ul>
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <td class="text-capitalize">8.</td>
                        <td class="text-capitalize">2023-07-03</td>
                        <td>BPA-2023-015</td>
                        <td>Proposed Agricultural Processing Plant</td>
                        <td>Industrial Development</td>
                        <td>Suna East</td>
                        <td>Waijah</td>
                        <td>LR 5678/901</td>
                        <td>2023-07-08</td>
                        <td>Jennifer Kim</td>
                        <td class="text-black text-uppercase text-right"><strong>Water Resource Impact</strong></td>
                        <td>Potential contamination of local water sources</td>
                        <td>
                          <div class="btn-group">
                            <button class="btn btn-danger btn-sm" data-toggle="modal" data-target="#details-3">View Rejection Details</button>
                            <button class="btn btn-secondary btn-sm dropdown-toggle" type="button" data-bs-toggle="dropdown" aria-expanded="false"></button>
                            <ul class="dropdown-menu">
                              <li><a class="dropdown-item" href="#">Download Rejection Notice</a></li>
                            </ul>
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <td class="text-capitalize">9.</td>
                        <td class="text-capitalize">2023-07-12</td>
                        <td>BPA-2023-017</td>
                        <td>Proposed Telecommunications Tower</td>
                        <td>Infrastructure Development</td>
                        <td>Ndhiwa</td>
                        <td>Kabuoro</td>
                        <td>LR 8901/234</td>
                        <td>2023-07-15</td>
                        <td>Robert Chen</td>
                        <td class="text-black text-uppercase text-right"><strong>Aesthetic Concerns</strong></td>
                        <td>Potential visual pollution in scenic area</td>
                        <td>
                          <div class="btn-group">
                            <button class="btn btn-danger btn-sm" data-toggle="modal" data-target="#details-3">View Rejection Details</button>
                            <button class="btn btn-secondary btn-sm dropdown-toggle" type="button" data-bs-toggle="dropdown" aria-expanded="false"></button>
                            <ul class="dropdown-menu">
                              <li><a class="dropdown-item" href="#">Download Rejection Notice</a></li>
                            </ul>
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <td class="text-capitalize">10.</td>
                        <td class="text-capitalize">2023-07-20</td>
                        <td>BPA-2023-019</td>
                        <td>Proposed Renewable Energy Farm</td>
                        <td>Green Energy Project</td>
                        <td>Homa Bay town</td>
                        <td>Miranga</td>
                        <td>LR 4567/890</td>
                        <td>2023-07-25</td>
                        <td>Lisa Rodriguez</td>
                        <td class="text-black text-uppercase text-right"><strong>Wildlife Habitat Interference</strong></td>
                        <td>Potential disruption of local ecosystem</td>
                        <td>
                          <div class="btn-group">
                            <button class="btn btn-danger btn-sm" data-toggle="modal" data-target="#details-3">View Rejection Details</button>
                            <button class="btn btn-secondary btn-sm dropdown-toggle" type="button" data-bs-toggle="dropdown" aria-expanded="false"></button>
                            <ul class="dropdown-menu">
                              <li><a class="dropdown-item" href="#">Download Rejection Notice</a></li>
                            </ul>
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <td class="text-capitalize">11.</td>
                        <td class="text-capitalize">2023-07-28</td>
                        <td>BPA-2023-021</td>
                        <td>Proposed Multi-Story Parking Garage</td>
                        <td>Urban Infrastructure</td>
                        <td>Homabay</td>
                        <td>Township</td>
                        <td>LR 6789/012</td>
                        <td>2023-08-02</td>
                        <td>Thomas Wright</td>
                        <td class="text-black text-uppercase text-right"><strong>Traffic Impact Assessment Incomplete</strong></td>
                        <td>Insufficient traffic flow analysis</td>
                        <td>
                          <div class="btn-group">
                            <button class="btn btn-danger btn-sm" data-toggle="modal" data-target="#details-3">View Rejection Details</button>
                            <button class="btn btn-secondary btn-sm dropdown-toggle" type="button" data-bs-toggle="dropdown" aria-expanded="false"></button>
                            <ul class="dropdown-menu">
                              <li><a class="dropdown-item" href="#">Download Rejection Notice</a></li>
                            </ul>
                          </div>
                        </td>
                      </tr>

                      <tr>
                        <td class="text-capitalize">13.</td>
                        <td class="text-capitalize">2023-08-12</td>
                        <td>BPA-2023-025</td>
                        <td>Proposed Research Laboratory</td>
                        <td>Scientific Infrastructure</td>
                        <td>Suba</td>
                        <td>North</td>
                        <td>LR 2345/678</td>
                        <td>2023-08-18</td>
                        <td>Dr. Elizabeth Wong</td>
                        <td class="text-black text-uppercase text-right"><strong>Safety Protocol Gaps</strong></td>
                        <td>Inadequate biosafety and containment measures</td>
                        <td>
                          <div class="btn-group">
                            <button class="btn btn-danger btn-sm" data-toggle="modal" data-target="#details-3">View Rejection Details</button>
                            <button class="btn btn-secondary btn-sm dropdown-toggle" type="button" data-bs-toggle="dropdown" aria-expanded="false"></button>
                            <ul class="dropdown-menu">
                              <li><a class="dropdown-item" href="#">Download Rejection Notice</a></li>
                            </ul>
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <td class="text-capitalize">14.</td>
                        <td class="text-capitalize">2023-08-20</td>
                        <td>BPA-2023-027</td>
                        <td>Proposed Heritage Museum</td>
                        <td>Cultural Infrastructure</td>
                        <td>Rachuonyo South</td>
                        <td>Ahero</td>
                        <td>LR 5678/901</td>
                        <td>2023-08-25</td>
                        <td>Carlos Martinez</td>
                        <td class="text-black text-uppercase text-right"><strong>Historical Preservation Concerns</strong></td>
                        <td>Potential damage to adjacent historical sites</td>
                        <td>
                          <div class="btn-group">
                            <button class="btn btn-danger btn-sm" data-toggle="modal" data-target="#details-3">View Rejection Details</button>
                            <button class="btn btn-secondary btn-sm dropdown-toggle" type="button" data-bs-toggle="dropdown" aria-expanded="false"></button>
                            <ul class="dropdown-menu">
                              <li><a class="dropdown-item" href="#">Download Rejection Notice</a></li>
                            </ul>
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <td class="text-capitalize">15.</td>
                        <td class="text-capitalize">2023-08-28</td>
                        <td>BPA-2023-029</td>
                        <td>Proposed Agricultural Research Center</td>
                        <td>Agricultural Innovation</td>
                        <td>Homa Bay town</td>
                        <td>Chache</td>
                        <td>LR 8901/234</td>
                        <td>2023-09-02</td>
                        <td>Karen Phillips</td>
                        <td class="text-black text-uppercase text-right"><strong>Land Use Conflict</strong></td>
                        <td>Proposed site overlaps with agricultural preservation zone</td>
                        <td>
                          <div class="btn-group">
                            <button class="btn btn-danger btn-sm" data-toggle="modal" data-target="#details-3">View Rejection Details</button>
                            <button class="btn btn-secondary btn-sm dropdown-toggle" type="button" data-bs-toggle="dropdown" aria-expanded="false"></button>
                            <ul class="dropdown-menu">
                              <li><a class="dropdown-item" href="#">Download Rejection Notice</a></li>
                            </ul>
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <td class="text-capitalize">16.</td>
                        <td class="text-capitalize">2023-09-05</td>
                        <td>BPA-2023-031</td>
                        <td>Proposed Sports Complex</td>
                        <td>Recreational Infrastructure</td>
                        <td>Homa Bay town</td>
                        <td>Central</td>
                        <td>LR 4567/890</td>
                        <td>2023-09-10</td>
                        <td>Marcus Johnson</td>
                        <td class="text-black text-uppercase text-right"><strong>Accessibility Non-Compliance</strong></td>
                        <td>Inadequate provisions for persons with disabilities</td>
                        <td>
                          <div class="btn-group">
                            <button class="btn btn-danger btn-sm" data-toggle="modal" data-target="#details-3">View Rejection Details</button>
                            <button class="btn btn-secondary btn-sm dropdown-toggle" type="button" data-bs-toggle="dropdown" aria-expanded="false"></button>
                            <ul class="dropdown-menu">
                              <li><a class="dropdown-item" href="#">Download Rejection Notice</a></li>
                            </ul>
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <td class="text-capitalize">17.</td>
                        <td class="text-capitalize">2023-09-13</td>
                        <td>BPA-2023-033</td>
                        <td>Proposed Eco-Tourism Lodge</td>
                        <td>Tourism Development</td>
                        <td>Homa Bay town</td>
                        <td>Ogembo</td>
                        <td>LR 6789/012</td>
                        <td>2023-09-18</td>
                        <td>Rachel Green</td>
                        <td class="text-black text-uppercase text-right"><strong>Environmental Sustainability Concerns</strong></td>
                        <td>Insufficient green building and conservation strategies</td>
                        <td>
                          <div class="btn-group">
                            <button class="btn btn-danger btn-sm" data-toggle="modal" data-target="#details-3">View Rejection Details</button>
                            <button class="btn btn-secondary btn-sm dropdown-toggle" type="button" data-bs-toggle="dropdown" aria-expanded="false"></button>
                            <ul class="dropdown-menu">
                              <li><a class="dropdown-item" href="#">Download Rejection Notice</a></li>
                            </ul>
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <td class="text-capitalize">18.</td>
                        <td class="text-capitalize">2023-09-21</td>
                        <td>BPA-2023-035</td>
                        <td>Proposed Emergency Response Center</td>
                        <td>Public Safety Infrastructure</td>
                        <td>Homa Bay town</td>
                        <td>Homa Bay town</td>
                        <td>LR 9012/345</td>
                        <td>2023-09-26</td>
                        <td>Daniel Rodriguez</td>
                        <td class="text-black text-uppercase text-right"><strong>Communication Infrastructure Deficiency</strong></td>
                        <td>Inadequate telecommunications and emergency communication plans</td>
                        <td>
                          <div class="btn-group">
                            <button class="btn btn-danger btn-sm" data-toggle="modal" data-target="#details-3">View Rejection Details</button>
                            <button class="btn btn-secondary btn-sm dropdown-toggle" type="button" data-bs-toggle="dropdown" aria-expanded="false"></button>
                            <ul class="dropdown-menu">
                              <li><a class="dropdown-item" href="#">Download Rejection Notice</a></li>
                            </ul>
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <td class="text-capitalize">19.</td>
                        <td class="text-capitalize">2023-09-29</td>
                        <td>BPA-2023-037</td>
                        <td>Proposed Urban Farming Center</td>
                        <td>Agricultural Innovation</td>
                        <td>Homa Bay town</td>
                        <td>Keumbu</td>
                        <td>LR 2345/678</td>
                        <td>2023-10-04</td>
                        <td>Emma Thompson</td>
                        <td class="text-black text-uppercase text-right"><strong>Soil Contamination Risk</strong></td>
                        <td>Potential soil quality issues in proposed site</td>
                        <td>
                          <div class="btn-group">
                            <button class="btn btn-danger btn-sm" data-toggle="modal" data-target="#details-3">View Rejection Details</button>
                            <button class="btn btn-secondary btn-sm dropdown-toggle" type="button" data-bs-toggle="dropdown" aria-expanded="false"></button>
                            <ul class="dropdown-menu">
                              <li><a class="dropdown-item" href="#">Download Rejection Notice</a></li>
                            </ul>
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <td class="text-capitalize">20.</td>
                        <td class="text-capitalize">2023-10-07</td>
                        <td>BPA-2023-039</td>
                        <td>Proposed Renewable Energy Training Center</td>
                        <td>Educational Infrastructure</td>
                        <td>Manga</td>
                        <td>Borabu</td>
                        <td>LR 5678/901</td>
                        <td>2023-10-12</td>
                        <td>Alexander Kim</td>
                        <td class="text-black text-uppercase text-right"><strong>Grid Connection Complexity</strong></td>
                        <td>Unresolved technical challenges for energy grid integration</td>
                        <td>
                          <div class="btn-group">
                            <button class="btn btn-danger btn-sm" data-toggle="modal" data-target="#details-3">View Rejection Details</button>
                            <button class="btn btn-secondary btn-sm dropdown-toggle" type="button" data-bs-toggle="dropdown" aria-expanded="false"></button>
                            <ul class="dropdown-menu">
                              <li><a class="dropdown-item" href="#">Download Rejection Notice</a></li>
                            </ul>
                          </div>
                        </td>
                      </tr>
                      </tbody>
                    </table>


                    <!-- Details Modals -->
                    <div class="modal fade" id="details-1" tabindex="-1" role="dialog"
                         aria-labelledby="details-1-label" aria-hidden="true">
                      <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
                        <div class="modal-content">
                          <div class="modal-header">
                            <h5 class="modal-title" id="details-1-label">Application
                              Details: BPA-2023-001</h5>
                            <button type="button" class="close" data-dismiss="modal"
                                    aria-label="Close">
                              <span aria-hidden="true">&times;</span>
                            </button>
                          </div>
                          <div class="modal-body">
                            <!-- Application details content goes here -->
                          </div>
                          <div class="modal-footer">
                            <button type="button" class="btn btn-secondary"
                                    data-dismiss="modal">Close</button>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="modal fade" id="details-2" tabindex="-1" role="dialog"
                         aria-labelledby="details-2-label" aria-hidden="true">
                      <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
                        <div class="modal-content">
                          <div class="modal-header">
                            <h5 class="modal-title" id="details-2-label">Application
                              Details: BPA-2023-002</h5>
                            <button type="button" class="close" data-dismiss="modal"
                                    aria-label="Close">
                              <span aria-hidden="true">&times;</span>
                            </button>
                          </div>
                          <div class="modal-body">
                            <!-- Application details content goes here -->
                          </div>
                          <div class="modal-footer">
                            <button type="button" class="btn btn-secondary"
                                    data-dismiss="modal">Close</button>
                          </div>
                        </div>
                      </div>
                    </div>

                    <!-- Your table code remains the same -->

                    <!-- Details Modals -->
                    <!-- Your table code remains the same -->

                    <!-- Details Modals -->
                    <!-- Your table code remains the same -->

                    <!-- Details Modals -->
                    <div class="modal fade" id="details-3" tabindex="-1" role="dialog" aria-labelledby="details-1-label" aria-hidden="true">
                      <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
                        <div class="modal-content">
                          <div class="modal-header ">
                            <h5 class="modal-title" id="details-1-label">Rejected Application: BPA-2023-001</h5>
                            <button type="button" class="close text-white" data-dismiss="modal" aria-label="Close">
                              <span aria-hidden="true">&times;</span>
                            </button>
                          </div>
                          <div class="modal-body">
                            <div class="alert alert-danger" role="alert">
                              <strong>Rejection Reason:</strong> Incomplete Environmental Impact Assessment
                            </div>

                            <h6>Applicant Details</h6>
                            <p>
                              <strong>Name:</strong> John Doe<br>
                              <strong>Email:</strong> john.doe@example.com<br>
                              <strong>Phone:</strong> +254 (723) 456-7890
                            </p>

                            <h6>Project Details</h6>
                            <p>
                              <strong>Project Name:</strong> Proposed Residential House<br>
                              <strong>Plot Number:</strong> LR 1234/567<br>
                              <strong>Development Type:</strong> New Buildings<br>
                              <strong>Site Location:</strong> Homa Bay Town, Arujo Ward<br>
                              <strong>Sub County:</strong> Homa Bay Town<br>
                              <strong>Ward:</strong> Arujo
                            </p>

                            <h6>Rejection Details</h6>
                            <p>
                              <strong>Rejection Date:</strong> 2023-05-20<br>
                              <strong>Rejected By:</strong> John Doe (Senior Environmental Officer)<br>
                              <strong>Department:</strong> Environmental Assessment Unit
                            </p>

                            <h6>Specific Deficiencies</h6>
                            <ul>
                              <li>Incomplete biodiversity impact analysis</li>
                              <li>Lack of comprehensive ecosystem assessment</li>
                              <li>Missing detailed mitigation strategies</li>
                              <li>Insufficient documentation on potential environmental disruptions</li>
                            </ul>

                            <h6>Recommended Actions</h6>
                            <ol>
                              <li>Conduct a comprehensive environmental impact study</li>
                              <li>Engage local environmental experts</li>
                              <li>Provide detailed mitigation and conservation plans</li>
                              <li>Resubmit updated environmental documentation</li>
                            </ol>

                            <h6>Uploaded Documents</h6>
                            <ul class="text-muted">
                              <li><del>Architectural Drawings</del> (Insufficient detail)</li>
                              <li><del>Structural Drawings</del> (Incomplete environmental context)</li>
                              <li><del>Site Plan</del> (Lacks ecological assessment)</li>
                              <li>Title Deed</li>
                              <li>KRA PIN Certificate</li>
                            </ul>

                            <h6>Payment Details</h6>
                            <p>
                              <strong>Application Fee Paid:</strong> KES 5,000<br>
                              <strong>Payment Date:</strong> 2023-05-17<br>
                              <strong>Payment Status:</strong> Non-refundable processing fee
                            </p>
                          </div>
                          <div class="modal-footer">
                            <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
                            <button type="button" class="btn btn-primary">Request Clarification</button>
                          </div>
                        </div>
                      </div>
                    </div>

                    <!-- Similar modals for Application 2 and 3 -->
                    ...

                    <!-- Similar modals for Application 2 and 3 -->
                    ...

                    <!-- Similar modals for Application 2 and 3 -->
                    ...

                    <!-- Approval Modals -->
                    <div class="modal fade" id="approve-1" tabindex="-1" role="dialog"
                         aria-labelledby="approve-1-label" aria-hidden="true">
                      <div class="modal-dialog modal-dialog-centered" role="document">
                        <div class="modal-content">
                          <div class="modal-header">
                            <h5 class="modal-title" id="approve-1-label">Approve Application
                            </h5>
                            <button type="button" class="close" data-dismiss="modal"
                                    aria-label="Close">
                              <span aria-hidden="true">&times;</span>
                            </button>
                          </div>
                          <div class="modal-body">
                            <form>
                              <div class="form-group">
                                <label for="approval-comments-1">Approval
                                  Comments</label>
                                <textarea class="form-control" id="approval-comments-1"
                                          rows="3"></textarea>
                              </div>
                            </form>
                          </div>
                          <div class="modal-footer">
                            <button type="button" class="btn btn-secondary"
                                    data-dismiss="modal">Cancel</button>
                            <button type="button" class="btn btn-success">Approve</button>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="modal fade" id="approve-2" tabindex="-1" role="dialog"
                         aria-labelledby="approve-2-label" aria-hidden="true">
                      <div class="modal-dialog modal-dialog-centered" role="document">
                        <div class="modal-content">
                          <div class="modal-header">
                            <h5 class="modal-title" id="approve-2-label">Approve Application
                            </h5>
                            <button type="button" class="close" data-dismiss="modal"
                                    aria-label="Close">
                              <span aria-hidden="true">&times;</span>
                            </button>
                          </div>
                          <div class="modal-body">
                            <form>
                              <div class="form-group">
                                <label for="approval-comments-2">Approval
                                  Comments</label>
                                <textarea class="form-control" id="approval-comments-2"
                                          rows="3"></textarea>
                              </div>
                            </form>
                          </div>
                          <div class="modal-footer">
                            <button type="button" class="btn btn-secondary"
                                    data-dismiss="modal">Cancel</button>
                            <button type="button" class="btn btn-success">Approve</button>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="modal fade" id="approve-3" tabindex="-1" role="dialog"
                         aria-labelledby="approve-3-label" aria-hidden="true">
                      <div class="modal-dialog modal-dialog-centered" role="document">
                        <div class="modal-content">
                          <div class="modal-header">
                            <h5 class="modal-title" id="approve-3-label">Approve Application
                            </h5>
                            <button type="button" class="close" data-dismiss="modal"
                                    aria-label="Close">
                              <span aria-hidden="true">&times;</span>
                            </button>
                          </div>
                          <div class="modal-body">
                            <form>
                              <div class="form-group">
                                <label for="approval-comments-3">Approval
                                  Comments</label>
                                <textarea class="form-control" id="approval-comments-3"
                                          rows="3"></textarea>
                              </div>
                            </form>
                          </div>
                          <div class="modal-footer">
                            <button type="button" class="btn btn-secondary"
                                    data-dismiss="modal">Cancel</button>
                            <button type="button" class="btn btn-success">Approve</button>
                          </div>
                        </div>
                      </div>
                    </div>

                    <!-- Decline Modals -->
                    <div class="modal fade" id="decline-1" tabindex="-1" role="dialog"
                         aria-labelledby="decline-1-label" aria-hidden="true">
                      <div class="modal-dialog modal-dialog-centered" role="document">
                        <div class="modal-content">
                          <div class="modal-header">
                            <h5 class="modal-title" id="decline-1-label">Decline Application
                            </h5>
                            <button type="button" class="close" data-dismiss="modal"
                                    aria-label="Close">
                              <span aria-hidden="true">&times;</span>
                            </button>
                          </div>
                          <div class="modal-body">
                            <form>
                              <div class="form-group">
                                <label for="decline-reason-1">Reason for
                                  Declining</label>
                                <textarea class="form-control" id="decline-reason-1"
                                          rows="3" required></textarea>
                              </div>
                            </form>
                          </div>
                          <div class="modal-footer">
                            <button type="button" class="btn btn-secondary"
                                    data-dismiss="modal">Cancel</button>
                            <button type="button" class="btn btn-danger">Decline</button>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="modal fade" id="decline-2" tabindex="-1" role="dialog"
                         aria-labelledby="decline-2-label" aria-hidden="true">
                      <div class="modal-dialog modal-dialog-centered" role="document">
                        <div class="modal-content">
                          <div class="modal-header">
                            <h5 class="modal-title" id="decline-2-label">Decline Application
                            </h5>
                            <button type="button" class="close" data-dismiss="modal"
                                    aria-label="Close">
                              <span aria-hidden="true">&times;</span>
                            </button>
                          </div>
                          <div class="modal-body">
                            <form>
                              <div class="form-group">
                                <label for="decline-reason-2">Reason for
                                  Declining</label>
                                <textarea class="form-control" id="decline-reason-2"
                                          rows="3" required></textarea>
                              </div>
                            </form>
                          </div>
                          <div class="modal-footer">
                            <button type="button" class="btn btn-secondary"
                                    data-dismiss="modal">Cancel</button>
                            <button type="button" class="btn btn-danger">Decline</button>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="modal fade" id="decline-3" tabindex="-1" role="dialog"
                         aria-labelledby="decline-3-label" aria-hidden="true">
                      <div class="modal-dialog modal-dialog-centered" role="document">
                        <div class="modal-content">
                          <div class="modal-header">
                            <h5 class="modal-title" id="decline-3-label">Decline Application
                            </h5>
                            <button type="button" class="close" data-dismiss="modal"
                                    aria-label="Close">
                              <span aria-hidden="true">&times;</span>
                            </button>
                          </div>
                          <div class="modal-body">
                            <form>
                              <div class="form-group">
                                <label for="decline-reason-3">Reason for
                                  Declining</label>
                                <textarea class="form-control" id="decline-reason-3"
                                          rows="3" required></textarea>
                              </div>
                            </form>
                          </div>
                          <div class="modal-footer">
                            <button type="button" class="btn btn-secondary"
                                    data-dismiss="modal">Cancel</button>
                            <button type="button" class="btn btn-danger">Decline</button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- end col -->
          </div>





        </div>
        <!-- container-fluid -->
      </div>
      <!-- End Page-content -->


      <!-- bootstrap modal -->
      <div class="modal fade" id="changeStream" tabindex="-1" role="dialog"
           aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title" id="exampleModalLongTitle">Change Revenue Stream</h5>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <div class="row">
                <div class="col-lg-12">
                  <div>
                    <label class="form-label">Select New Revenue Stream</label>
                    <select class="form-control selectpicker bg-white" title="Select Revenue Stream"
                            data-live-search="true">
                      <option value=" ">Failing to carry and produce a driving license on demand.
                      </option>
                      <option value=" ">Exceeding speed limit prescribed for class of vehicle by
                        1-5 KPH</option>
                      <option value=" ">Exceeding speed limit prescribed for class of vehicle by
                        6-10 KPH</option>
                      <option value=" ">Exceeding speed limit prescribed for class of vehicle by
                        11-15 KPH</option>
                      <option value=" ">Exceeding speed limit prescribed for class of vehicle by
                        16-20 KPH</option>
                    </select>
                  </div>
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-primary w-100 text-center">Save changes</button>
            </div>
          </div>
        </div>
      </div>
      <!-- end of changing revenue stream modal -->


      <footer class="footer ">
        <div class="container-fluid ">
          <div class="row ">
            <div class="col-sm-6 ">
            </div>
            <div class="col-sm-6 ">
              <div class="text-sm-end d-sm-block ">
                Best Birdy Billing system.
              </div>
            </div>
          </div>
        </div>
      </footer>
    </div>

    <!-- end main content-->



  </div>
  <!-- END layout-wrapper -->

  <!-- Right bar overlay-->
  <div class="rightbar-overlay "></div>

  </body>

</template>

<script>
/* eslint-disable */

import NavigationBar from "@/components/Navigation";

export default {
  name: "eConstructionStats",
  components: { NavigationBar},
  data() {
    return {

    }

  },
  watch: {
  },

  mounted() {


  },
  methods: {

  },
  computed:{

  }
}
</script>


<style scoped>

</style>